import { useEffect, useState, useCallback } from 'react';
import { toast } from 'sonner';
import { fetchDashboard } from '../../lib/api';

/**
 * useDashboardData — hook per il caricamento iniziale + reload.
 *
 * Espone:
 *   - data    : risposta /api/dashboard (anno, obiettivi, numeri_importanti, copertura)
 *   - loading : true durante il primo fetch + reload
 *   - reload(): re-fetch (es. dopo save tema, seed)
 *
 * Side-effect: ascolta `qp:areas-changed` (emesso da AreaManager) e forza
 * un nuovo fetch della dashboard così COPERTURA AREE + Obiettivi raggruppati
 * si aggiornano subito senza un refresh manuale.
 */
export function useDashboardData() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const d = await fetchDashboard();
      setData(d);
    } catch (e) {
      toast.error('Errore nel caricamento della dashboard');
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, []);

  // Primo fetch
  useEffect(() => {
    reload();
  }, [reload]);

  // Ricarica su evento aree cambiate
  useEffect(() => {
    const onAreasChanged = () => reload();
    window.addEventListener('qp:areas-changed', onAreasChanged);
    return () => window.removeEventListener('qp:areas-changed', onAreasChanged);
  }, [reload]);

  return { data, loading, reload };
}
